import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { WorkOrderPriority } from "src/util/types/dataModels/workOrderPriority"

//region Types

export type WorkOrderPriorityDocument = RxDocument<WorkOrderPriority>
export type WorkOrderPriorityCollection = RxCollection<WorkOrderPriority>

//endregion

/**
 * Schema for work order priority collections
 */
export const workOrderPrioritySchema: RxJsonSchema<WorkOrderPriority> = {
  title: "Work Order Priority schema",
  description: "Collection of all work order priorities",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    designation: { type: "string", maxLength: 100 },
    rank: { type: "number", maximum: 100, minimum: 1 },
    work_domain: { ref: "work_domain_workspace", type: "string", maxLength: 36 },
  },
  required: ["id", "designation", "rank", "work_domain"],
  indexes: ["designation"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const workOrderPriorityCollectionCreator: RxCollectionCreator = {
  schema: workOrderPrioritySchema,
}
